export default {
    url: '',
    template: '<ui-view></ui-view>',
    abstract: true,
    resolve: {
        classifiers (ClassifierResource) {
            // we add pageSize 0 because we want all the classifiers
            return ClassifierResource.query({ pageSize: 0 }).$promise;
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/index.js